module.exports = __webpack_public_path__ + "img/google_signin_logo.fa78718e.svg";